import { createAsyncThunk } from '@reduxjs/toolkit';
import { iStateMessage } from '@/customTypes/GenericReduxTypes';
import { iGenericResponse } from '@/customTypes/CommonServiceTypes';
import { curryGetThunkName } from '@/projectUtils/ReduxUtil';
import { httpStatusCodes } from '@/customTypes/NetworkTypes';

import { appListService } from '@/services/api/cresivoxServer';
import { REDUCER_NAME } from './Types';

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

/**
 * Get App List
 */
export const getAppList = createAsyncThunk<
  iGenericResponse<any | null> | null,
  void,
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName('getAppList'),
  // @ts-expect-error backend response typing
  async (_, { rejectWithValue }) => {
    try {
      const response = await appListService.getAppList();

      if (!response) {
        return rejectWithValue({ message: 'No response received' });
      }

      const { httpStatusCode, data, message } = response;

      switch (httpStatusCode) {
        case httpStatusCodes.SUCCESS_OK: {
          if (data && data.data) {
            return {
              data: {
                httpStatusCode,
                data: data.data,
                message,
              },
            };
          }
          return rejectWithValue({ httpStatusCode, message });
        }

        default:
          return rejectWithValue({ httpStatusCode, message });
      }
    } catch (error) {
      return rejectWithValue({
        message: 'Something went wrong',
      });
    }
  }
);

// export const saveAppDetails = createAsyncThunk(
//   'appList/saveAppDetails',
//   async (payload: any, { rejectWithValue }) => {
//     try {
//       const response = await appListService.saveAppDetails(payload);
//       return response.data;
//     } catch (error: any) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

export const saveAppDetails = createAsyncThunk(
  curriedGetThunkName('saveAppDetails'),
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await appListService.saveAppDetails(payload);
      if (!response || response.httpStatusCode !== 200) {
        return rejectWithValue(response?.message || 'Failed to save');
      }
      return response.data;
    } catch (error: any) {
      return rejectWithValue({ message: 'Something went wrong' });
    }
  }
);

export const initiateAppBuildPayment = createAsyncThunk(
  curriedGetThunkName('initiateAppBuildPayment'),
  async (
    { amount, appType }: { amount: number; currency: string; appType: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await appListService.initiateAppPayment({
        amount,
        appType,
      });
      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                data: {
                  data: data.data,
                  message,
                },
              };
            } else {
              return rejectWithValue({ httpStatusCode, message });
            }
          }
          default: {
            return rejectWithValue({ httpStatusCode, message });
          }
        }
      } else {
        return rejectWithValue({ message: 'No response received' });
      }
    } catch (error) {
      return rejectWithValue({ message: 'Something went wrong' });
    }
  }
);
